var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"app-body"},[(_vm.showNav)?_c('navbar'):_vm._e(),_c('v-main',[_c('router-view')],1),(_vm.$route.name !== 'approve')?_c('footerBar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }